import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { Observable } from 'rxjs';
import {
  Activity,
  BaseComponent,
  ConfigurationSetting,
  MyClaim,
  NewClaim,
  NotificationItem,
  OffWork,
  TabGroupComponent,
} from 'src/app/shared';
import { ClaimInfo, SearchResult } from 'src/app/shared/models/search-result';
import { DisplayService, UserRoleService } from '../..';
import { UserActionService } from '../../../shared';
import { ActivityService } from '../../services/activity.service';
import { ClaimService } from '../../services/claim.service';
import { ConfigurationService } from '../../services/configuration.service';
import { Session } from '../../services/session.service';
import { ReportNewClaimComponent } from '../report-new-claim/report-new-claim.component';
import { AccommodationJobFunction } from '../../models/accommodation';
import { UserActions } from '../../../shared/models/user';
import { TranslationRequest } from 'src/app/shared/models/translation/translation-request';

@Component({
  selector: 'app-activity',
  template: `
    <div id="activitypnl">
      <app-panel
        title="Activity"
        [showTitle]="showTitle"
        minHeight="510px"
        [class.mat-elevation-z0]="flat"
        [flat]="flat"
      >
        @if (showMyClaims && !isClaim) {
          <div class="tw-w-full app-pt2">
            <app-loading-panel [state]="!isLoaded ? 'Loading' : 'Loaded'">
              <ng-template #content>
                @if (showMyClaims && !isClaim) {
                  <app-my-claims
                    featurename="MyClaims"
                    [myClaimsLoaded]="isLoaded"
                    [myClaims]="listOfClaims"
                    [translationRequest]="translationRequest"
                    [accommodationsJobFunctions]="accommodationsData"
                  ></app-my-claims>
                }
              </ng-template>
            </app-loading-panel>
          </div>
        }
        @if (!showTitle) {
          <div class="app-pt2"></div>
        }
        <app-tab-group
          [tabGroupId]="'activitiesTabGroup'"
          [sectionName]="featureSectionName + 'Activity'"
        >
          <app-tab
            [visible]="paymentTabVisible"
            label="Payments"
            id="paymentsTab"
            featureName="Payments"
            [template]="payments"
          >
            <ng-template #payments>
              <div class="app-pt3"></div>
              <app-custom-message
                [listClientMessage]="this.claim?.listClientMessage"
                [keyForMessage]="'Payments'"
              >
              </app-custom-message>
              <app-payment
                [claim]="claim"
                [isHomePage]="isHomePage"
                [paymentsDataMyClaims]="activities.payments"
                [paymentMyClaims]="listOfClaims"
                [translationRequest]="translationRequest"
              ></app-payment>
            </ng-template>
          </app-tab>

          @if (showNewClaims) {
            <app-tab
              label="New Claims"
              id="newClaimsTab"
              featureName="New Claims"
              [template]="newClaims"
            >
              <ng-template #newClaims>
                @if (showNewClaims && isLoaded) {
                  <app-new-claims
                    [newClaims]="activities.newClaims"
                    featurename="NewClaims"
                  ></app-new-claims>
                }
              </ng-template>
            </app-tab>
          }

          <app-tab
            [visible]="showNotifications"
            label="Notifications"
            id="notificationTab"
            featureName="Notifications"
            name="Notifications"
            [template]="notifications"
          >
            <ng-template #notifications>
              @if (isLoaded) {
                <app-notifications
                  [notifications]="activities?.notifications"
                  [actualNotifications]="activities?.notifications"
                  [ntnMyClaims]="activities"
                  [mgrAction]="mgrAction"
                  [showFilter]="isFilterApplied"
                  (clearFilterEvent)="onClearFilter()"
                  [showClaimLink]="!isClaim"
                ></app-notifications>
              }
            </ng-template>
          </app-tab>

          <app-tab
            label="Return to Work"
            featureName="ReturnToWork"
            name="returntowork"
            [visible]="isReturnToWork"
            [template]="returnToWork"
          >
            <ng-template #returnToWork>
              @if (isLoaded && isReturnToWork) {
                <app-return-to-work
                  [returnToWork]="activities.returnToWork"
                  [translationRequest]="translationRequest"
                ></app-return-to-work>
              }
            </ng-template>
          </app-tab>
          <app-tab
            label="Off Work"
            [visible]="showOffWork && !isClaim"
            featureName="OffWork"
            id="offWorkTab"
            [template]="offWork"
          >
            <ng-template #offWork>
              @if (isLoaded) {
                <app-off-work
                  [offWork]="activities.offWork"
                  [ClientLevelConfig]="ClientLevelConfig"
                  [yourClaim]="yourClaim"
                  [translationRequest]="translationRequest"
                ></app-off-work>
              }
            </ng-template>
          </app-tab>
          <app-tab
            label="Accommodations"
            [visible]="showAccommodations"
            featureName="Accommodations"
            id="accommodations"
            [template]="accommodations"
          >
            <ng-template #accommodations>
              <app-accommodation-page
                [ClientLevelConfig]="ClientLevelConfig"
                [isClaimSummary]="false"
                [accommodations]="accommodationsData"
                [translationRequest]="translationRequest"
              ></app-accommodation-page>
            </ng-template>
          </app-tab>
        </app-tab-group>
      </app-panel>
    </div>
  `,
  styles: [``],
  standalone: false,
})
export class ActivityComponent extends BaseComponent implements OnInit {
  @ViewChild(TabGroupComponent) tabGroup: TabGroupComponent;
  @Input() focusTab: EventEmitter<string>;

  @ViewChild('dialogReportNewClaim') dialogRefReportNewClaim: TemplateRef<any>;
  @Input()
  showTitle = true;

  @Input()
  focus = 'myclaims';

  selectedIndex = 100;

  @Input()
  claimInfo$ = new Observable<ClaimInfo>();

  @Input()
  translationRequest: TranslationRequest;

  @Input()
  claimConfig: ConfigurationSetting;

  @Input()
  ClientLevelConfig: ConfigurationSetting;

  @Input()
  isClaim: boolean = false;

  @Input()
  hideReportClaim: boolean = false;

  @Input()
  claim: SearchResult;

  @Input()
  flat = false;

  @Input()
  isHomePage: boolean = false;
  //parameterize this when we refactor dashboards for multiple users? Or get
  yourClaim: boolean = false;

  offWork: OffWork[];

  returnToWork: OffWork[];

  notifications: NotificationItem[];

  newClaims: NewClaim[];

  @Input()
  listOfClaims: MyClaim[];

  @Input()
  activities: Activity;

  paymentTabVisible: boolean;

  isLoaded: boolean = false;

  @Input()
  isFilterApplied: boolean = false;

  @Output()
  clearFilter = new EventEmitter<void>();

  @Output()
  valueChanged = new EventEmitter<any>();

  myClaims: MyClaim[];
  isClaimant: boolean = false;
  isEmployee: boolean = false;
  isAuditor: boolean = false;
  showNewClaims: boolean = true;
  showNotifications: boolean = true;
  showOffWork: boolean = true;
  showMyClaims: boolean = false;
  hasReportClaim: boolean = false;
  showActivityFilter: boolean;
  isReturnToWork: boolean = false;
  setToastButnShow: boolean;
  hasFeatureEnabled: boolean = false;
  showAccommodations: boolean = false;
  featureSectionName: string = '';
  @Input()
  mgrAction: UserActions | null;
  isManager: boolean = false;

  @Input()
  accommodationsData: AccommodationJobFunction[];
  @Output()
  setPaymentAlertBool = new EventEmitter<boolean>();

  // activity: Activity;

  get isRtw(): boolean {
    // Return to Work Feature not in scope, so just not displaying if we are on claim and client  doesnt have LOB WC
    //return !this.isClaim && this.claimConfigService.getFeatureAccess('ReturnToWork');
    //const hasWc =
    //  this.session.user.lineOfBusiness.filter((l) => l.lob == 'WC').length > 0;
    return this.isClaim || this.userrole.manager;
    // new requirements say it will always be visible for supervisor
  }

  constructor(
    public claimConfigService: ConfigurationService,
    private activityService: ActivityService,
    public session: Session,
    private change: ChangeDetectorRef,
    public dialog: MatDialog,
    public claimService: ClaimService,
    public userrole: UserRoleService,
    public display: DisplayService,
    private userAction: UserActionService,
  ) {
    super();
  }

  async ngOnInit() {
    this.selectedIndex = 0;
    this.isClaimant = this.userrole.claimant;
    this.isEmployee = this.userrole.employee;
    this.isManager = this.userrole.manager;
    this.showNotifications = this.display.notifications;
    this.isReturnToWork = this.display.rtw;
    this.showNewClaims = this.display.newClaims;
    this.showOffWork = this.display.offWork;
    this.showMyClaims = this.display.myClaims;
    this.hasReportClaim = this.display.reportClaim;
    this.showAccommodations = this.display.accommodations;
    const managerAction = this.userAction.getAction();

    if (managerAction == UserActions.ViewOwnMgrDb) {
      this.featureSectionName = 'Manager ';
    } else if (managerAction == UserActions.MgrViewEmpDb) {
      this.featureSectionName = 'Managers Employee ';
    }

    this.showActivityFilter =
      this.isClaimant || this.isEmployee ? false : !this.isClaim;

    this.subs.sink = this.claimInfo$.subscribe(async () => {
      this.subs.sink = this.activityService.focusNotification.subscribe(
        (x: string) => {
          this.setTabIndex(x);
          this.change.markForCheck();
        },
      );

      this.paymentTabVisible = await this.showPaymentTab();
    });
    // focus tab will not be set for controller
    if (this.focusTab) {
      this.subs.sink = this.focusTab.subscribe((tabId: string) => {
        this.setTabIndex(tabId);
      });
    }
    this.isLoaded = true;
  }

  async showPaymentTab(): Promise<boolean> {
    if (
      this.userrole.manager &&
      this.userAction.getAction() == UserActions.ViewOwnMgrDb
    ) {
      this.setPaymentAlertBool.emit(false);
      return false;
    } else if (
      this.userrole.manager &&
      this.listOfClaims &&
      (this.userAction.getAction() == UserActions.MgrViewEmpDb ||
        this.userAction.getAction() == UserActions.ViewOwnEmpDb)
    ) {
      const data1 = await this.HasAnyClaimHaveFeature(
        'payments',
        this.listOfClaims,
      );
      this.setPaymentAlertBool.emit(data1);
      return data1;
    } else if (
      (this.userrole.claimant || this.userrole.employee) &&
      this.listOfClaims
    ) {
      const paymentTab = await this.HasAnyClaimHaveFeature(
        'payments',
        this.listOfClaims,
      );
      const data = paymentTab && !this.session.user.isClaimClosed;
      this.setPaymentAlertBool.emit(data);
      return data;
    }
    this.setPaymentAlertBool.emit(false);
    return false;
  }

  HasAnyClaimHaveFeature(
    featureName: string,
    listOfClaims: MyClaim[],
  ): boolean {
    if (!listOfClaims?.length) {
      return false;
    }
    for (let i = 0; i < listOfClaims.length; i++) {
      const features = listOfClaims[i]?.claimLevelFeatures;
      if (features?.indexOf(featureName) > -1) {
        this.hasFeatureEnabled = true;
        break;
      }
    }
    return this.hasFeatureEnabled;
  }


  setTabIndex(index: string) {
    this.tabGroup.selectTab(index);
  }

  onClearFilter() {
    this.clearFilter.emit();
  }

  reportClaim() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.data = {
      title: 'Confirmation',
    };
    this.dialog.open(ReportNewClaimComponent, dialogConfig);
  }
}
